import { render, staticRenderFns } from "./BankClosedDetailList.vue?vue&type=template&id=19128a62"
import script from "./BankClosedDetailList.vue?vue&type=script&lang=js"
export * from "./BankClosedDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports